import {
  GET_POSTS,
  SEARCH_POSTS,
  SET_LOADING,
  SET_READMORE_LOADING,
  LOAD_MORE_POSTS,
  GET_FILTRED_POSTS,
  SET_ORDER,
} from '../types';

export default (state, action) => {
  switch(action.type) {
    case GET_POSTS:
      return {
        ...state,
        posts: action.payload,
        loading: false,
        readMoreloading: false,
        maxPages: action.maxPages,
        foundPosts: action.foundPosts
      }
    case SEARCH_POSTS:
      return {
        ...state,
        posts: action.payload,
        loading: false,
        readMoreloading: false,
        maxPages: action.maxPages,
        foundPosts: action.foundPosts
      }
    case SET_LOADING:
      return {
        ...state,
        loading: true,
        readMoreloading: false
      }
    case SET_READMORE_LOADING:
      return {
        ...state,
        readMoreloading: true
      }
    case LOAD_MORE_POSTS:
      return {
        ...state,
        posts: state.posts.concat(action.payload),
        loading: false,
        readMoreloading: false,
        maxPages: action.maxPages,
        foundPosts: action.foundPosts
      }
    case GET_FILTRED_POSTS:
      return {
        ...state,
        posts: action.payload,
        loading: false,
        readMoreloading: false,
        maxPages: action.maxPages,
        foundPosts: action.foundPosts
      }
    case SET_ORDER:
      return {
        ...state,
        posts: action.payload,
        loading: false,
        readMoreloading: false,
        maxPages: action.maxPages,
        foundPosts: action.foundPosts
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/context/app/appReducer.js